<template>
  <div class="list-card">
    <template v-for="item in aplysList" :key="item">
      <div class="card-item">
        <p class="row1">
          <span>
            <img class="first"
              :src="item.examAttendYn == 'Y' ? require('@/assets/ico-join-on.svg') : require('@/assets/ico-join-off.svg')"
              width="24" height="24">
            <img
              :src="item.quizDownYn == 'Y' ? require('@/assets/filedown-on.png') : require('@/assets/filedown-off.png')"
              width="24" height="24">
          </span>
          <v-spacer></v-spacer>
          <span>
            <img
              :src="item.answerUploadYn == 'Y' ? require('@/assets/fileup-on.png') : require('@/assets/fileup-off.png')"
              width="83" height="24">
          </span>
        </p>
        <p class="row2">
          <span class="first">NO</span>
          <span class="second">{{ item.num }}</span>
        </p>
        <p class="row3">{{ item.name }}</p>
      </div>
    </template>
    <div class="card-item-nodata" v-if="aplysList.length <= 0">
      {{t('nodata')}}
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

const props = defineProps({
  aplysList: {
    type: Array,
    default: () => []
  },
})

</script>
<style lang="scss" scoped>
@import '@/sass/app.scss';

.list-card {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: repeat(auto-fill, minmax(227px, 1fr));
  gap: 0 16px;
  row-gap: 16px;
  margin-bottom: 32px;
}

.card-item {
  width: 100%;
  height: 100%;
  min-height: 152px;
  border-radius: 24px;
  padding: 24px 20px;
  border: dashed 1px #666;
  font-family: 'Pretendard GOV';

  p {
    width: 100%;
  }

  p.row1 {
    display: flex;
    margin-bottom: 12px;
    height: 24px;

    img.first {
      margin-right: 3px;
    }
  }

  p.row2 {
    width: 100%;
    min-height: 29px;
    margin-bottom: 3px;

    span.first {
      font-size: 15px;
      letter-spacing: -0.8px;
      line-height: 15px;
      font-weight: 500;
      font-family: 'Pretendard GOV';
      color: #acacac;
      margin-right: 4px;
    }

    span.second {
      font-size: 19px;
      line-height: 20px;
      font-family: 'Pretendard GOV';
      color: #111;
      font-weight: bold;
      word-break: break-all;
    }
  }

  p.row3 {
    font-size: 16px;
    letter-spacing: -0.8px;
    line-height: 18px;
    font-family: 'Pretendard GOV';
    color: #666;
    word-break: break-all;
  }
}

.card-item.on {
  background-color: #f7f7f7;
}

.card-item.off {
  background-color: #fff;
}

.card-item-nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 152px;
  border-radius: 24px;
  padding: 24px 20px;
  border: dashed 1px #666;
  font-family: 'Pretendard GOV';
}
</style>
